(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aarchive-whatnot-live-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const POLL_FALLBACK_MS = 60000;
    const ROTATION_MS = 6000;

    const initializeBanner = (root) => {
      if (root.dataset.whatnotBannerInitialized === 'true') return;
      root.dataset.whatnotBannerInitialized = 'true';

      const slides = Array.from(root.querySelectorAll('[data-whatnot-banner-slide]'));
      const showSlide = root.querySelector('[data-whatnot-banner-show]');
      const message = root.querySelector('[data-whatnot-banner-message]');
      const previous = root.querySelector('[data-whatnot-banner-previous]');
      const next = root.querySelector('[data-whatnot-banner-next]');
      const nativeAnnouncement = document.querySelector('.announcement-bar-section');
      const nativeAnnouncementState = nativeAnnouncement
        ? {
            hidden: nativeAnnouncement.hasAttribute('hidden'),
            style: nativeAnnouncement.getAttribute('style'),
            ariaHidden: nativeAnnouncement.getAttribute('aria-hidden')
          }
        : null;
      if (!slides.length || !showSlide || !message) return;

      let pollTimer;
      let rotationTimer;
      let activeIndex = 0;
      let paused = false;

      const stopRotation = () => {
        window.clearTimeout(rotationTimer);
      };

      const restoreNativeAnnouncement = () => {
        if (!nativeAnnouncement || !nativeAnnouncementState) return;
        nativeAnnouncement.toggleAttribute('hidden', nativeAnnouncementState.hidden);
        if (nativeAnnouncementState.style === null) {
          nativeAnnouncement.removeAttribute('style');
        } else {
          nativeAnnouncement.setAttribute('style', nativeAnnouncementState.style);
        }
        if (nativeAnnouncementState.ariaHidden === null) {
          nativeAnnouncement.removeAttribute('aria-hidden');
        } else {
          nativeAnnouncement.setAttribute('aria-hidden', nativeAnnouncementState.ariaHidden);
        }
      };

      const replaceNativeAnnouncement = () => {
        if (!nativeAnnouncement) return;
        nativeAnnouncement.setAttribute('hidden', '');
        nativeAnnouncement.setAttribute('aria-hidden', 'true');
        nativeAnnouncement.style.setProperty('display', 'none', 'important');
      };

      const setActiveSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.hidden = !isActive;
          slide.setAttribute('aria-hidden', String(!isActive));
        });
      };

      const startRotation = () => {
        stopRotation();
        if (paused || root.hidden || slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        rotationTimer = window.setTimeout(() => {
          setActiveSlide(activeIndex + 1);
          startRotation();
        }, ROTATION_MS);
      };

      const hide = () => {
        stopRotation();
        slides.forEach((slide) => {
          slide.hidden = true;
          slide.setAttribute('aria-hidden', 'true');
        });
        root.hidden = true;
        root.removeAttribute('data-state');
        restoreNativeAnnouncement();
      };

      const schedule = (seconds) => {
        window.clearTimeout(pollTimer);
        const safeSeconds = Number.isFinite(Number(seconds)) ? Number(seconds) : 60;
        pollTimer = window.setTimeout(refresh, Math.max(30, safeSeconds) * 1000);
      };

      const formatEasternTime = (value) => {
        const startsAt = new Date(value);
        if (Number.isNaN(startsAt.getTime())) return '';
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        }).formatToParts(startsAt);
        const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        if (!values.hour || !values.dayPeriod) return '';
        const minutes = values.minute === '00' ? '' : `:${values.minute}`;
        const period = values.dayPeriod.toUpperCase() === 'AM' ? 'a.m.' : 'p.m.';
        return `${values.hour}${minutes} ${period} Eastern`;
      };

      const render = (payload) => {
        const banners = payload && Array.isArray(payload.banners) ? payload.banners : [];
        const banner = banners.find((candidate) => candidate && candidate.show_url);
        if (payload.visible !== true || !banner) {
          hide();
          return;
        }

        const isLive = banner.state === 'live';
        const startsAt = formatEasternTime(banner.starts_at);
        const timingLabel = startsAt
          ? `${root.dataset.upcomingLabel} ${root.dataset.timeConnector} ${startsAt}`
          : root.dataset.upcomingLabel;
        const label = isLive ? root.dataset.liveLabel : timingLabel;
        const title = String(banner.show_title || '').trim();
        const visibleMessage = title ? `${label} — ${title}` : label;

        message.textContent = visibleMessage;
        showSlide.href = banner.show_url;
        showSlide.setAttribute('aria-label', `${visibleMessage}. ${root.dataset.watchLabel}`);
        root.dataset.state = banner.state;
        replaceNativeAnnouncement();
        root.hidden = false;
        setActiveSlide(0);
        startRotation();
      };

      const refresh = async () => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 5000);
        try {
          const response = await fetch(root.dataset.statusUrl, {
            headers: { Accept: 'application/json' },
            mode: 'cors',
            cache: 'no-store',
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Whatnot status HTTP ${response.status}`);
          const payload = await response.json();
          render(payload);
          schedule(payload.refresh_after_seconds);
        } catch (_error) {
          hide();
          schedule(POLL_FALLBACK_MS / 1000);
        } finally {
          window.clearTimeout(timeout);
        }
      };

      previous?.addEventListener('click', () => {
        setActiveSlide(activeIndex - 1);
        startRotation();
      });
      next?.addEventListener('click', () => {
        setActiveSlide(activeIndex + 1);
        startRotation();
      });
      root.addEventListener('mouseenter', () => {
        paused = true;
        stopRotation();
      });
      root.addEventListener('mouseleave', () => {
        paused = false;
        startRotation();
      });
      root.addEventListener('focusin', () => {
        paused = true;
        stopRotation();
      });
      root.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (root.contains(document.activeElement)) return;
          paused = false;
          startRotation();
        }, 0);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') refresh();
      });
      refresh();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-aarchive-whatnot-live-banner]').forEach(initializeBanner);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-aarchive"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
